<template>
  <div id="BackHeader" class="back-header" :style="styles">
    <span class="back" @click="goBack">
      <i class="gjw-iconfont gjw-icon-gongneng_houtui arrow"></i>
      <span>{{title}}</span>
    </span>
    <slot name="bread"></slot>
  </div>
</template>

<script>
export default {
  name: 'BackHeader',
  props: {
    // 设置背景色等样式
    styles: {
      type: Object,
      default() {
        return {}
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .back-header{
    height: 40px;
    line-height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .back{
      color: @theme-color;
      cursor: pointer;
      font-size: 14px;
      margin-right: 12px;
    }
    .arrow{
      margin-right: 10px;
    }
  }
  .bread{
    font-size: 14px;
    padding-left: 14px;
    position: relative;
    margin-top: 2px;
    &:before{
      content: '';
      position: absolute;
      left: 0;
      top: 8px;
      width: 2px;
      height: 24px;
      background: @theme-border-color;
    }
  }
</style>
